import PickUpgradeCollection from "../upgrade/ore/PickUpgradeCollection";
import PickUpgrade from "../upgrade/ore/PickUpgrade";

export default class PickUpgradeCollectionSave {
    constructor() {        
    }

    /**
     * @param {PickUpgradeCollection} pickUpgradeCollection
     * @returns {Object}
     */
    static generateSave(pickUpgradeCollection) {
        const saveState = {};

        saveState.upgrades = [];

        for (let i = 0; i < pickUpgradeCollection.upgrades.length; i++) {
            const upgradeSave = this.generateUpgradeSave(pickUpgradeCollection.upgrades[i]);
            if (!upgradeSave) {
                continue;
            }

            saveState.upgrades.push(upgradeSave);
        }

        saveState.countToPurchase = pickUpgradeCollection.countToPurchase;

        return saveState;
    }

    /**
     * @param {PickUpgradeCollection} upgradeCollection
     * @param {Object} saveState 
     */
    static loadSave(upgradeCollection, saveState) {
        if (!saveState) {
            console.log('PickUpgradeCollectionSave.loadSave no save state');
            return;
        }

        const upgradeSaves = saveState.upgrades;
        if (!upgradeSaves) {
            console.log('PickUpgradeCollectionSave.loadSave state empty');
            return;
        }

        for (let i = 0; i < saveState.upgrades.length; i++) {
            this.loadUpgradeSave(upgradeCollection, saveState.upgrades[i]);
        }

        const countToPurchase = saveState.countToPurchase;
        if (countToPurchase) {
            upgradeCollection.setCountToPurchase(countToPurchase);
        }
    }

    /**
     * @private
     * @param {PickUpgrade} upgrade 
     * @returns {Object}
     */
    static generateUpgradeSave(upgrade) {
        // Nothing to save if there have been no purchases
        if (upgrade.purchasedCount === 0) {
            return null;
        }

        const upgradeState = {};
 
        upgradeState.id = upgrade.id;
        upgradeState.c = upgrade.purchasedCount;

        return upgradeState;
    }

    /**
     * @private
     * @param {PickUpgradeCollection} pickUpgradeCollection
     * @param {Object} upgradeState
     */
    static loadUpgradeSave(pickUpgradeCollection, upgradeState) {
        if (!upgradeState) {
            return;
        }

        const id = upgradeState.id;
        const upgrade = pickUpgradeCollection.findById(id);
        if (!upgrade) {
            console.log('PickUpgradeCollectionSave.loadUpgradeSave() failed to find upgrade id=' + id);
            return;
        }

        const count = upgradeState.c;
        if (count === undefined) {
            return;
        }

        ////////upgrade.setPurchasedCount(count);
        upgrade.setPurchasedCountFromSave(count);
    }

}